<template>
    <div class="modal__footer">
        <slot />
    </div>
</template>
<script setup>
</script>
<style scoped lang="scss">
.modal {
    &__footer {
        z-index: 1;
        position: sticky;
        bottom: 0;
        background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff 15%, #fff);
        display: flex;
        justify-content: end;
        margin-top: auto;
    }
}
</style>